<template>
    <div>
        
        <!-- Encabezado de la Aplicación -->
        <div class="appHeader no-border transparent position-absolute">
            <div class="left">
                <a href="#" class="headerButton goBack">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle"></div>
            <div class="right">
            </div>
        </div>
        <!-- * Encabezado de la Aplicación -->

        <!-- Cápsula de la Aplicación -->
        <div id="appCapsule">

            <div class="section mt-2 text-center">
                <h1>¿Olvidó su contraseña?</h1>
                <h4>Ingrese su correo electrónico para restablecer su contraseña</h4>
            </div>
            <div class="section mb-5 p-2">
                <form @submit.prevent="formSubmit">
                    <div class="card">
                        <div class="card-body pb-1">

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="email1">Correo electrónico</label>
                                    <input type="email" class="form-control" id="email1" placeholder="Su correo electrónico" v-model="email" />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-button-group transparent">
                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="sending">Restablecer contraseña</button>
                    </div>

                </form>
            </div>

        </div>
        <!-- * Cápsula de la Aplicación -->

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            sending: false,
            email: null,
        };
    },
    mounted() {
        this.$root.loadBackButtom();
        this.$root.loadInputs();
    },
    methods: {
        ...mapActions(['v1_recoveryAPI']),
        async formSubmit() {
            console.log('formSubmit')
            this.sending = true;
            const response = await this.v1_recoveryAPI({ email: this.email });
            console.log('response', response)
            this.sending = false
        }
    }
}
</script>